export const ROUTES = {
  COMPANY_LIST: '/document-verification/company',
  COMPANY_DOCUMENTS: '/document-verification/company/:id'
}
